import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

import "../../../css/catalog/catalog.scss";

//import main module definition.
import catalogModule from '../catalog/catalogModule';

importFilesUnderPath(require.context("../catalog/filters/", true, /\.js$/));
importFilesUnderPath(require.context("../catalog/constants/", true, /\.js$/));
importFilesUnderPath(require.context("../catalog/directives/", true, /\.js$/));
importFilesUnderPath(require.context("./directives/", true, /\.js$/));
importFilesUnderPath(require.context("../catalog/controllers/", true, /\.js$/));
importFilesUnderPath(require.context("./controllers/", true, /\.js$/));
importFilesUnderPath(require.context("../catalog/services/", true, /\.js$/));

let templateContext = require.context("../catalog/", true, /\.html$/);
let templateDesktopContext = require.context("./", true, /\.html$/);

const templates = templateCacheGenerator(angular, 'catalogPageTemplates', templateContext, templateDesktopContext);

// self manual initialization
angular.element(function () {
    angular.bootstrap("#catalog-container", [catalogModule.name, templates.name]);
});
